import Vue from 'vue'
import App from './App.vue'
import './registerServiceWorker'
import router from './router'
import store from './store'

import { GridPlugin } from '@syncfusion/ej2-vue-grids';
import { TextBoxPlugin } from '@syncfusion/ej2-vue-inputs';
import { ButtonPlugin, CheckBoxPlugin } from '@syncfusion/ej2-vue-buttons';
import { DialogPlugin } from '@syncfusion/ej2-vue-popups';
import { DropDownListPlugin } from '@syncfusion/ej2-vue-dropdowns';
import { DatePickerPlugin, TimePickerPlugin } from '@syncfusion/ej2-vue-calendars';
import { ToastPlugin } from '@syncfusion/ej2-vue-notifications';
import { L10n, setCulture } from '@syncfusion/ej2-base';

Vue.use(GridPlugin);
Vue.use(TextBoxPlugin);
Vue.use(ButtonPlugin);
Vue.use(CheckBoxPlugin);
Vue.use(DialogPlugin);
Vue.use(DropDownListPlugin);
Vue.use(DatePickerPlugin);
Vue.use(TimePickerPlugin);
Vue.use(ToastPlugin);

setCulture('cro-HR');

L10n.load({
    'cro-HR': {
        'grid': {
            'EmptyRecord': 'Nema podataka za prikaz.',
        }
    }
});

Vue.config.productionTip = false

new Vue({
    router,
    store,
    App,
    render: h => h(App)
}).$mount('#app')